import React, {useState} from 'react';
import {Button} from 'react-bootstrap';
import PropTypes from 'prop-types';
import ContentCopyIcon from '@mui/icons-material/ContentCopyRounded';
import CheckIcon from '@mui/icons-material/CheckRounded';

/**
 * Displays a command/secret in a monospace block with a copy-to-clipboard button.
 */
const CopyableCommand = ({value, label}) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Copy failed:', err);
    }
  };

  return (
    <div>
      {label && (
        <div className="mb-1" style={{fontSize: 13, color: 'var(--text-secondary)'}}>{label}</div>
      )}
      <div
        className="d-flex align-items-start gap-2 p-2 rounded"
        style={{background: 'var(--surface-2, #1e1e1e)', border: '1px solid var(--border, #333)'}}
      >
        <code
          style={{
            flex: 1,
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-all',
            fontSize: 12,
            color: 'var(--text-primary)'
          }}
        >
          {value}
        </code>
        <Button
          size="sm"
          variant={copied ? 'success' : 'outline-secondary'}
          onClick={handleCopy}
          title="Copy to clipboard"
          style={{flexShrink: 0}}
        >
          {copied ? <CheckIcon style={{fontSize: 16}}/> : <ContentCopyIcon style={{fontSize: 16}}/>}
        </Button>
      </div>
    </div>
  );
};

CopyableCommand.propTypes = {
  value: PropTypes.string.isRequired,
  label: PropTypes.string
};

export default CopyableCommand;
